import CustomElement from '~utilities/custom-element';
import 'url-search-params-polyfill';
const IS_LOADING = 'is--loading';
const IS_ACTIVE = 'is--active';
const IS_DISABLED = 'is--disabled';
const JS_ADVANCED_FILTER = 'js-advanced-filter';
const ADVANCED_FILTER = 'advanced-filter';
const DESC = 'desc';
const ASC = 'asc';

class AdvancedFilter extends CustomElement {
	constructor() {
		super();
	}

	callback() {
		super.callback();
		this.options();
		this.categoryFilters = [];
		this.searchFilters = '';
		this.sortFilters = '';
		this.page = 1;
		this.filterEntries = this.element.querySelector('[js-advanced-filter-entries]'); // filtered items
		this.filterItems = [...this.element.querySelectorAll('[js-advanced-filter-item]')]; // categories, on click
		this.filterSearch = this.element.querySelector('[js-advanced-filter-search]'); // search, on click search button
		this.filterSearchInput = this.filterSearch.querySelector('[js-advanced-filter-search-input]');
		this.filterSorts = [...this.element.querySelectorAll('[js-advanced-filter-sort]')]; // sort, on click
		this.filterReset = this.element.querySelector('[js-advanced-filter-reset]'); // reset filter
		this.filterSelection = this.element.querySelector('[js-advanced-filter-selection');
		this.filterLoadMore = this.element.querySelector('[js-advanced-filter-load');
		this.filterUrl = this.element.dataset.filterUrl;

		if(this.filterUrl) {
			if(this.url) this.getFilterUrl();
			
			this.addData(`${this.filterUrl}?categories=${this.categoryFilters.join()}&search=${this.searchFilters}&sort=${this.sortFilters}&type=${this.element.dataset.filterType}&page=${this.page}`);
			this.bindEvents();
			this.applyFilterSelection();
		}
	}

	bindEvents() {
		this.filterItems.forEach((item) => {
			item.addEventListener('change', () => this.categoryFilter());
		});

		const filterSearchButton = this.filterSearch.querySelector('[js-advanced-filter-search-button]');
		filterSearchButton.addEventListener('click', (e) => {
			e.preventDefault();
			this.searchFilter();
		});

		this.filterReset.addEventListener('click', () => {
			this.resetFilter();
		});

		this.filterLoadMore.addEventListener('click', () => {
			this.nextPage();
		});

		this.filterSorts.forEach((sort) => {
			sort.addEventListener('click', () => this.sortFilter(sort));
		});
	}

	options() {
        let attributes = this.element.getAttribute(JS_ADVANCED_FILTER);
        if(!attributes) return;
        attributes = attributes.split('|');
        
        attributes.forEach(attribute => {
            switch(attribute) {
                case 'url':
                    this.url = true;
                    break;
                default:
                    console.warn(`advanced-filter.options(): ${attribute} is not an option.`);
                    break;
            }
        });
    }

	nextPage() {
		if(this.page > this.lastPage){
			this.page++
			this.addData(`${this.filterUrl}?categories=${this.categoryFilters.join()}&search=${this.searchFilters}&sort=${this.sortFilters}&type=${this.element.dataset.filterType}&page=${this.page}`, false);
		}
	}

	resetFilter() {
		this.filterItems.forEach(filterItem => {
			if(filterItem.options){
				filterItem.selectedIndex = 0;
				filterItem.nextElementSibling.innerText = filterItem.options[filterItem.selectedIndex].innerText;
			} else {
				filterItem.checked = false;
			}

			filterItem.removeAttribute('disabled');
			filterItem.classList.remove(IS_DISABLED);
		});

		this.categoryFilters = [];
		this.searchFilters = '';
		this.filterSearchInput.value = '';
		this.addData(`${this.filterUrl}?type=${this.element.dataset.filterType}`);
		this.applyFilterSelection();


		this.setFilterUrl('search', false);
		this.setFilterUrl('categories', false);
		this.setFilterUrl('sort', false);
	}

	searchFilter() {
		let searchWords = this.filterSearchInput.value.toLowerCase().split(' ');
		searchWords = searchWords.join('+');

		this.searchFilters = searchWords;

		this.filter();
		this.applyFilterSelection();
		if(this.searchFilters) this.setFilterUrl('search', true, this.searchFilters);
	}

	setFilterUrl(type, toggle, data = '') {
		if(toggle) {
			this.filterUrlParams.set(`${ADVANCED_FILTER}-${type}`, data);
		} else {
			this.filterUrlParams.delete(`${ADVANCED_FILTER}-${type}`);
		}

		window.history.replaceState(null, null, `${window.location.href.split('?')[0]}${this.filterUrlParams.toString() ? `?${this.filterUrlParams}` : ''}`);
	}

	/*
		OPTIONS
		advanced-filter-search
		advanced-filter-categories
		advanced-filter-sort
	*/
	getFilterUrl() {
		this.filterUrlParams = new URLSearchParams(window.location.search);
		
		this.searchFilters = this.filterUrlParams.has(`${ADVANCED_FILTER}-search`) ? this.filterUrlParams.get(`${ADVANCED_FILTER}-search`) : '';
		this.sortFilters = this.filterUrlParams.has(`${ADVANCED_FILTER}-sort`) ? this.filterUrlParams.get(`${ADVANCED_FILTER}-sort`) : '';
		this.categoryFilters = this.filterUrlParams.has(`${ADVANCED_FILTER}-categories`) ? this.filterUrlParams.get(`${ADVANCED_FILTER}-categories`).split(",") : [];
		
		if(this.searchFilters) {
			this.filterSearchInput.value = this.searchFilters.split('+').join(' ');
		}

		if(this.sortFilters) {
			this.filterSorts.forEach(filterSort => {
				if(this.sortFilters.split(',')[0] === filterSort.getAttribute('js-advanced-filter-sort')) {
					filterSort.classList.add(`is--${this.sortFilters.split(',')[1]}`);
				}
			});
		}

		if(this.categoryFilters) {
			this.filterItems.forEach(filterItem => {
				if(filterItem.options){
					Array.prototype.forEach.call(filterItem, (option, index) => {
						if(this.categoryFilters.includes(option.value)) {
							filterItem.selectedIndex = index;
						}
					})
				} else if(this.categoryFilters.includes(filterItem.value)) {
					filterItem.checked = true;
				}
			});
		}
	}

	sortFilter(sort) {
		this.filterSorts.forEach(sibling => {
            if(sort !== sibling) sibling.classList.remove(`is--${DESC}`, `is--${ASC}`);
        });

		const sortOn = sort.getAttribute('js-advanced-filter-sort');
		const sortOrder = sort.classList.contains(`is--${ASC}`) ? DESC : ASC;
		sort.classList.remove(`is--${DESC}`, `is--${ASC}`);
		sort.classList.add(`is--${sortOrder}`);
		this.sortFilters = `${sortOn},${sortOrder}`;


		this.filter();
		this.setFilterUrl('sort', true, this.sortFilters);
	}

	filterItemsCount(catCounts) {
		this.filterItems.forEach((item) => {
			if(item.options){
				Object.keys(item.options).forEach((key) => {
					if (!catCounts.hasOwnProperty(item.options[key].value) && item.options[key].value) {
						item.options[key].classList.add(IS_DISABLED);
						item.options[key].setAttribute('disabled', '');
	
						try {
							const customItem = this.element.querySelector(
								`.dropdown__link[value=${item.options[key].value}]`
							);
							customItem.classList.add(IS_DISABLED);
						} catch (e) {
							console.error('forgot adding dropdown__link to option?');
						}
					} else {
						item.classList.remove(IS_DISABLED);
						item.removeAttribute('disabled');
					}
				});
			} if (!catCounts.hasOwnProperty(item.value) && item.value) {
				item.classList.add(IS_DISABLED);
				item.setAttribute('disabled', '');
			} else {
				item.classList.remove(IS_DISABLED);
				item.removeAttribute('disabled');
			}
		});
	}

	categoryFilter() {
		this.categoryFilters = [];
		const form = this.element.querySelector('[js-form]');
		Object.keys(form.elements).forEach((key) => {
			let element = form.elements[key];
			if (element.type !== 'checkbox' && element.type !== 'radio') {
				this.categoryFilters.push(element.value);
			} else if (element.checked) {
				this.categoryFilters.push(element.value);
			}
		});


		this.setFilterUrl('categories', true, this.categoryFilters);
		this.searchFilter(); //Also triggers this.filter();
	}

	filter() {
		this.addData(
			`${this.filterUrl}?categories=${this.categoryFilters.join()}&search=${this.searchFilters}&sort=${this.sortFilters}&type=${this.element.dataset.filterType}&page=${this.page}`
		);
		this.filterCallback();
	}

	// add searchable items to the search label overview
	applyFilterSelection() {
		if (!this.filterSelection) return;

		// remove previous results (also removes listeners)
		[...this.filterSelection.children].forEach((node) => node.remove());

		// merge search and categories and filter empty
		const filtered = [this.searchFilters, ...this.categoryFilters].filter((el) => el != '');

		if (filtered.length > 0) {
			filtered.forEach((item) => {
				const filterFound = document.createElement('a');
				filterFound.innerText = item;
				filterFound.classList.add('filter__found');
				filterFound.setAttribute('filter', item);
				filterFound.addEventListener('click', () => {
					this.removeItemFromFilter(item);
					this.filter();
				});
				this.filterSelection.appendChild(filterFound);
			});
		} else {
			const filterFound = document.createElement('span');
			filterFound.classList.add('filter__found', 'filter__found--empty');
			filterFound.innerText = 'Geen filter geselecteerd';
			this.filterSelection.appendChild(filterFound);
		}
	}

	removeItemFromFilter(clickedFilterItem) {
		if(this.searchFilters === clickedFilterItem) {
			this.searchFilters = '';
			this.filterSearchInput.value = '';
			this.setFilterUrl('search', false);
		} else {
			this.categoryFilters = this.categoryFilters.filter(item => item !== clickedFilterItem);
			this.filterItems.forEach(filterItem => {
				if(filterItem.options && filterItem.options[filterItem.selectedIndex].value === clickedFilterItem){
					filterItem.selectedIndex = 0;
					filterItem.nextElementSibling.innerText = filterItem.options[filterItem.selectedIndex].innerText;
				} else if(filterItem.value === clickedFilterItem) {
					filterItem.checked = false;
				}

				this.setFilterUrl('categories', true, this.categoryFilters);
			});
		}

		this.applyFilterSelection();
	}

	filterCallback() {
		// Developer can overrule this function.
		// For example: show the selected filters with this.categoryFilters
	}

	addData(url, removeOld = true) {
		if(removeOld) {
			this.page = 1;
			this.filterEntries.classList.add(IS_LOADING);
			this.removeOldData();
		}

		fetch(url)
			.then((response) => {
				return response.json();
			})
			.then((response) => {
				this.createEntries(response.data);
				this.lastPage = response.last_page;
				this.createCount(response.total);
				this.filterItemsCount(response.cat_counts);
				this.filterEntries.classList.remove(IS_LOADING);
				
				if(this.page >= this.lastPage) this.filterLoadMore.classList.add('is--hidden');
			});
	}

	removeOldData() {
		this.filterEntries.innerHTML = '';
	}

	createEntries(elements) {
		Object.keys(elements).forEach((key) => {
			this.createEntry(elements[key]);
		});
	}

	createEntry(entry) {
		this.filterEntries.insertAdjacentHTML(
			'beforeend',
			`
            <div class="advanced-filter__entries-item ${entry.active ? IS_ACTIVE : ''}" 
                data-filter-categories='${entry.categories}'>
                ${this.entryTemplate(entry)}
            </div>
        `
		);
	}

	createCount(count) {
		const filterCount = this.element.querySelector('[js-advanced-filter-count]');
		filterCount.innerText = count;
	}

	entryTemplate(entry) {
		return `
			<div>
				<h2>${entry.specialism}</h2>
				<p>${entry.title}</p>
			</div>
	  `;
	}
}

export default AdvancedFilter;
